import React from 'react'
import PropTypes from 'prop-types'
import { InfoWindow } from '@react-google-maps/api'
import { Link } from 'react-router-dom'

const MapPopupMetada = ({ data }) => {
  return (
    <div>
      <Link to={data.link ? data.link : '#'} className="flex justify-between mb-1 items-center">
        <div className="text-xs mr-8">{data.name}</div>
        <div className={`text-xs font-semibold ${data.link ? '' : ''}`}>{data.count}</div>
      </Link>
    </div>
  )
}

const MapPopupMetadataWithSubdata = ({ data }) => {
  return (
    <div className="mb-2">
      <Link to={data.link ? data.link : '#'} className="flex justify-between mb-1 items-center">
        <div className="text-xs mr-8 font-semibold">{data.name}</div>
        <div className={`text-xs font-semibold ${data.link ? '' : ''}`}>{data.count}</div>
      </Link>
      {data.subData.map((v, i) => (
        <Link to={v.link ? v.link : '#'} key={i} className="flex justify-between mb-1 ml-2 items-center">
          <div className="text-xs mr-8">{v.name}</div>
          <div className={`text-xs ${v.link ? '' : ''}`}>{v.count}</div>
        </Link>
      ))}
    </div>
  )
}

const MapPopup = ({ data, onMouseOver, onMouseOut }) => {
  const onHover = () => {
    // setIsOpen(true)
    onMouseOver(data)
  }

  const onHoverOut = () => {
    // setIsOpen(false)
    onMouseOut(data)
  }

  return (
    <InfoWindow
      position={data.coordinate}
      options={{
        pixelOffset: new window.google.maps.Size(0, -20),
      }}
    >
      <div style={{ maxWidth: '200px' }} className="text-black font-primary" onMouseOver={onHover} onMouseOut={onHoverOut}>
        <Link to={data.link ? data.link : '#'} className="flex justify-between mb-2 items-center pb-2 border-b border-solid" style={{borderColor: '#ddd'}}>
          <div className="font-bold mr-8 text-base">{data.name}</div>
          <div className={`text-xs font-semibold ${data.link ? '' : ''}`}>{data.total ? data.total : ''}</div>
        </Link>
        {
          data.metadata &&
          data.metadata.map((v, i) => (
            ('subData' in v) ? <MapPopupMetadataWithSubdata data={v} key={i} /> : <MapPopupMetada data={v} key={i} />
          ))
        }
        {
          data.content &&
          (
            <div className="text-xs" dangerouslySetInnerHTML={{__html: data.content}}></div>
          )
        }
        {
          (data.content && data.link) &&
          (
            <div className="mt-4">
              <Link to={data.link} className="text-xs  font-semibold text-primary">View</Link>
            </div>
          )
        }
      </div>
    </InfoWindow>
  )
}

MapPopup.propTypes = {
  data: PropTypes.object.isRequired,
  onMouseOver: PropTypes.func,
  onMouseOut: PropTypes.func,
}

MapPopup.defaultProps = {
  onMouseOver: () => {},
  onMouseOut: () => {},
}

export { MapPopup }
